import React, {
  createContext,
  PropsWithChildren,
  useContext,
  ComponentType
} from 'react';
import { Global } from '@emotion/react';
import { typography, cssReset } from './foundations';

const GlobalStylesContext = createContext({});

export function useGlobalStyles() {
  return useContext(GlobalStylesContext);
}

export const GlobalStylesProvider = (props: PropsWithChildren) => {
  const { children } = props;
  return (
    <GlobalStylesContext.Provider value={{}}>
      <Global styles={[typography]} />
      <div css={cssReset}>{children}</div>
    </GlobalStylesContext.Provider>
  );
};

export const withGlobalStylesProvider = <Props extends object>(
  WrappedComponent: React.ComponentType<Props>
) => {
  WrappedComponent.displayName = 'WrappedComponent';
  const GlobalStylesWrap = (props: Props) => (
    <GlobalStylesProvider>
      <WrappedComponent {...props} />
    </GlobalStylesProvider>
  );
  return GlobalStylesWrap;
};

export const withGlobalStylesDecorator = (Story: ComponentType) => {
  return (
    <GlobalStylesProvider>
      <Story />
    </GlobalStylesProvider>
  );
};
